<template>
  <v-text-field
    :disabled="field.readonly"
    :error-messages="errors"
    :hide-details="dense"
    :model-value="modelValue"
    :rules="rules"
    :type="field.type"
    @update:model-value="$emit('update:modelValue', $event)"
  >
    <template #label>
      <FieldLabel :field="field" />
    </template>

    <template
      v-if="field.icon"
      #prepend-inner
    >
      <vi-icon
        icon="mdi:car"
      />
    </template>
  </v-text-field>
</template>

<script setup lang="ts">
defineProps<{
  field: FieldConfig
  modelValue: string | string[] | undefined
  errors?: string[]
  dense?: boolean
  rules?: FormRule[]
}>();
defineEmits(['update:modelValue']);
</script>
